import React, { Component } from 'react';

class LoginInformation extends Component {
  render () {
    return (<div className='login-information'>
    </div>);
  }
}

export default LoginInformation;



/** WEBPACK FOOTER **
 ** ./src/views/login-view/tabs/login-information.js
 **/